module.exports = __webpack_public_path__ + "static/tt-desktop-stock-65c11d69432955286266d7f54b2d8f52.png";